'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverMenuItem = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(PopoverMenuItem, _PureComponent);

  function PopoverMenuItem() {
    (0, _classCallCheck3.default)(this, PopoverMenuItem);
    return (0, _possibleConstructorReturn3.default)(this, (PopoverMenuItem.__proto__ || (0, _getPrototypeOf2.default)(PopoverMenuItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(PopoverMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClick = _props.onClick,
          iconClass = _props.iconClass,
          title = _props.title,
          hidden = _props.hidden;


      if (hidden) {
        return null;
      }

      return _react2.default.createElement(
        'li',
        { onClick: onClick },
        title,
        ' ',
        _react2.default.createElement('i', { className: iconClass })
      );
    }
  }]);
  return PopoverMenuItem;
}(_react.PureComponent), _class.propTypes = {
  hidden: _propTypes2.default.bool,
  iconClass: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
}, _class.defaultProps = {
  onClick: _noop3.default
}, _temp);
exports.default = PopoverMenuItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PopoverMenu/PopoverMenuItem.js
// module id = 353
// module chunks = 1